import { cn } from '../../lib/cn'

interface WaveDividerProps {
  className?: string
  fill?: string
  flip?: boolean
  variant?: 'wave' | 'curve' | 'slope'
}

const paths: Record<NonNullable<WaveDividerProps['variant']>, string> = {
  wave: 'M0,64 C240,120 480,10 720,42 C960,74 1200,140 1440,80 L1440,160 L0,160 Z',
  curve: 'M0,96 C480,180 960,180 1440,96 L1440,160 L0,160 Z',
  slope: 'M0,160 L1440,32 L1440,160 Z',
}

/** Organic SVG divider for premium section transitions. */
export function WaveDivider({ className, fill = '#F7F5EF', flip = false, variant = 'wave' }: WaveDividerProps) {
  return (
    <div className={cn('pointer-events-none relative w-full overflow-hidden leading-[0]', flip && 'rotate-180', className)}>
      <svg viewBox="0 0 1440 160" preserveAspectRatio="none" className="block h-[70px] w-full md:h-[120px]" aria-hidden="true">
        <path d={paths[variant]} fill={fill} />
      </svg>
    </div>
  )
}
